<template>
  <custom-popup
    v-model="dialog"
    :cons="{ title: computedtitle, icon: 'format-list-bulleted-type' }"
  >
    <template v-slot:activator>
      <div class="rowinfo">
        <v-btn
          :class="!!value ? 'btn-edit' : 'btn-refund'"
          :loading="loading"
          class="ma-0"
          style="letter-spacing: normal"
        >
          <v-icon class="me-2">mdi-plus</v-icon>
          <span v-if="!!value">{{ computedtitle }}</span>
          <span v-else>{{ computedtitle }}</span>
        </v-btn>
      </div>
    </template>

    <!-- نمایش فرم ساخت پترن -->
    <create-pattern
      v-if="isOpenPattern"
      v-model="isOpenPattern"
      @refresh="reloadTable(tableProps)"
    />

    <!-- نمایش فرم ساخت کمپین -->
    <create-campaign
      v-else-if="isOpenCampaign"
      v-model="isOpenCampaign"
      @refresh="reloadTable(tableProps)"
    />

    <!-- نمایش لیست پترن‌ها و کمپین‌ها -->
    <v-card v-else :loading="loading" class="pa-4" flat>
      <v-card-title class="pa-2">
        <div class="rowinfo" v-if="showPattern">
          <v-btn
            class="btn-refund contentinfo pl-2"
            @click="isOpenPattern = true"
          >
            <v-icon class="me-2">mdi-plus</v-icon>
            ثبت پترن جدید
          </v-btn>
        </div>
        <div class="rowinfo" v-if="showCampaign">
          <v-btn
            class="btn-send-sms contentinfo pl-2"
            @click="isOpenCampaign = true"
          >
            <v-icon class="me-2">mdi-plus</v-icon>
            ثبت کمپین جدید
          </v-btn>
        </div>
      </v-card-title>
      <v-alert type="info" dense outlined class="mb-3">
        توجه: پترن یا کمپین‌های جدید پس از ثبت، باید توسط مسئول مربوطه تأیید
        شوند و سپس در سامانه قابل استفاده خواهند بود.
      </v-alert>

      <custom-tabs
        v-if="showPattern && showCampaign"
        v-model="tabs"
        :tab-items="tabItems"
        grow
      >
        <template v-slot:staticItems>
          <!-- 0: انتخاب پترن من -->
          <v-tab-item class="py-4">
            <data-table
              :columns="columns"
              :data="data"
              :per-page="[10, 25, 50, 100, 400]"
              :translate="translate"
              @row-clicked="selectRow"
              @on-table-props-changed="reloadTable"
            />
            <v-card
              v-if="(!data.data || !data.data.length) && !loading"
              class="text-muted text-center font-size-h3 d-flex align-center justify-center"
              flat
              height="200"
            >
              الگویی پیدا نشد، ابتدا یک الگو ثبت فرمایید.
            </v-card>
          </v-tab-item>

          <!-- 1: انتخاب کمپین من -->
          <v-tab-item class="py-4">
            <message-list ref="message-list-user" :camp-id.sync="campId" api-type="user" />
          </v-tab-item>

          <!-- 2: انتخاب پترن عمومی -->
          <v-tab-item class="py-4">
            <data-table
              :columns="columns"
              :data="data"
              :per-page="[10, 25, 50, 100, 400]"
              :translate="translate"
              @row-clicked="selectRow"
              @on-table-props-changed="reloadTable"
            />
            <v-card
              v-if="(!data.data || !data.data.length) && !loading"
              class="text-muted text-center font-size-h3 d-flex align-center justify-center"
              flat
              height="200"
            >
              الگویی پیدا نشد.
            </v-card>
          </v-tab-item>

          <!-- 3: انتخاب کمپین عمومی -->
          <v-tab-item class="py-4">
            <message-list ref="message-list-public" :camp-id.sync="campId" api-type="public" />
          </v-tab-item>
        </template>
      </custom-tabs>

      <!-- حالت‌های تکی (فقط پترن یا فقط کمپین) - پیش‌فرض روی اطلاعات کاربر تنظیم شده است -->
      <div v-else-if="showPattern" class="py-4">
        <data-table
          :columns="columns"
          :data="data"
          :per-page="[10, 25, 50, 100, 400]"
          :translate="translate"
          @row-clicked="selectRow"
          @on-table-props-changed="reloadTable"
        />
        <v-card
          v-if="(!data.data || !data.data.length) && !loading"
          class="text-muted text-center font-size-h3 d-flex align-center justify-center"
          flat
          height="200"
        >
          الگویی پیدا نشد، ابتدا یک الگو ثبت فرمایید.
        </v-card>
      </div>

      <div v-else-if="showCampaign" class="py-4">
        <message-list ref="message-list-user" :camp-id.sync="campId" api-type="user" />
      </div>
    </v-card>
  </custom-popup>
</template>

<script>
import CreatePattern from "./createPattern.vue";
import CreateCampaign from "./createCampaign.vue";
import MessageList from "./messageList.vue";
import { SmsAxios } from "@/main";

export default {
  name: "smsPatternPickerDigi",

  components: { MessageList, CreatePattern, CreateCampaign },

  props: {
    value: Object,
    rerender: Boolean,
    text: Array,
    mode: {
      type: String,
      default: "both",
      validator: (value) => ["both", "pattern", "campaign"].includes(value),
    },
  },

  data: () => ({
    isOpenPattern: false,
    isOpenCampaign: false,
    selectedRowId: null,
    tabItems: [
      {
        text: "انتخاب پترن من",
        value: "select_pattern_user",
        icon: "mdi-card-account-details-outline",
      },
      {
        text: "انتخاب کمپین من",
        value: "select_campaign_user",
        icon: "mdi-bullhorn-outline",
      },
      {
        text: "انتخاب پترن عمومی",
        value: "select_pattern_public",
        icon: "mdi-card-account-details-star-outline",
      },
      {
        text: "انتخاب کمپین عمومی",
        value: "select_campaign_public",
        icon: "mdi-bullhorn-variant-outline",
      },
    ],
    helpData: [],
    serviceName: "Qrland",
    componentName: "smspatternpicker",
    data: {},
    dialog: false,
    columns: [
      {
        label: "شناسه",
        name: "id",
        orderable: true,
      },
      {
        label: "نوع",
        name: "type",
        orderable: true,
        transform: ({ data }) => {
          return data.type === "pattern" ? "پترن" : "ثابت";
        },
      },
      {
        label: "عنوان",
        name: "title",
        orderable: true,
      },
      {
        label: "متن",
        name: "content",
        transform: ({ data }) => {
          return data.content.substr(0, 70) + "...";
        },
        orderable: true,
      },
      {
        label: "وضعیت",
        name: "active",
        transform: ({ data }) => {
          return data.active === 0
            ? `<p class="badge badge-danger">رد شده</p>`
            : `<p class="badge badge-success">تایید شده</p>`;
        },
        orderable: true,
      },
    ],
    translate: {
      nextButton: "بعدی",
      previousButton: "قبلی",
      rowsPerPageText: "تعداد در صفحه",
      noDataText: "داده ای برای نمایش وجود ندارد",
      placeholderSearch: "جستجو",
    },
    tableProps: {
      search: "",
      length: 10,
      column: "id",
      dir: "desc",
      active: 1,
    },
    tabs: 0,
    patternLoading: false,
    loading: false,
    mlModel: [],
    campId: null,
    selectedRow: null,
  }),

  mounted() {
  this.$nextTick(() => {
      this.getDefaultPattern();
    });
  },

  computed: {
    computedValue: {
      get() {
        return this.selectedRow;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    showPattern() {
      return this.mode === "both" || this.mode === "pattern";
    },
    showCampaign() {
      return this.mode === "both" || this.mode === "campaign";
    },
    computedtitle() {
      let text_title =
        this.mode === "both"
          ? " پترن/کمپین"
          : this.mode === "pattern"
          ? " پترن"
          : " کمپین";
      let sub_text =
        !!this.value && !!Object.keys(this.value).length ? "تغییر" : "انتخاب";
      return `${sub_text} ${text_title}`;
    },
  },

  watch: {
    dialog(val) {
      if (val) {
        this.isOpenPattern = false;
        this.isOpenCampaign = false;
        this.getData();
      }
    },
    campId(val) {
      this.selectCamp(val);
    },
    tabs(val) {
      if (val === 0 || val === 2) {
        this.tableProps.search = "";
        this.getData();
      }
    }
  },

  methods: {
    async getData(query = this.tableProps) {
      this.search = query.search;
      this.loading = true;
      try {
        const apiPath = this.tabs === 2 ? "text/public" : "text/user";

        const { data } = await SmsAxios.get(apiPath, {
          params: {
            ...query,
            active: 1,
          },
        });
        this.data = data;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    selectRow(data) {
      const id = data.id;

      $("tr").css("background", "");

      $(`tr:contains("${id}")`).each(function (index, item) {
        if ($(item).find("td").eq(0).text() === id)
          $(item).css("background", "rgba(99, 0, 244, 0.28)");
      });

      this.computedValue = data;
      this.dialog = false;
    },
    selectCamp(data) {
      const refName = this.tabs === 3 ? "message-list-public" : "message-list-user";
      const obj = this.$refs[refName]?.data?.data.find(
        (item) => item.id === data,
      );
      if (!obj) return;

      delete obj.id;

      this.computedValue = {
        ...obj,
        campId: data,
      };
      this.dialog = false;
    },
    reloadTable(tableProps) {
      this.tableProps = tableProps;
      this.getData(tableProps);
    },
   // جایگزین کردن این متدها در متدهای smsPatternPicker.vue
async getDefaultPattern() {
  // اگر مقدار اولیه پترن یا کمپین ارسال شده بود
  if (!this.value) return;
  
  const targetId = this.value.id || this.value.campId;
  if (!targetId) return;

  const isCampaign = !!this.value.campId;

  if (isCampaign) {
    return;
  }

  this.loading = true;
  try {
    let foundPattern = this.data?.data?.find(item => item.id == targetId);

    if (!foundPattern) {
      foundPattern = await this.fetchSinglePattern(targetId);
    }

    if (foundPattern) {
      this.computedValue = foundPattern;
      this.$emit("reload", true);
    }
  } catch (error) {
    console.error("Error fetching default pattern:", error);
  } finally {
    this.loading = false;
  }
},

async fetchSinglePattern(id) {
  try {
    let response = await SmsAxios.get(`text/user`, {
      params: { id: id, active: 1 }
    });
    let pattern = response.data?.data?.find(item => item.id == id);
    
    if (!pattern) {
      response = await SmsAxios.get(`text/public`, {
        params: { id: id, active: 1 }
      });
      pattern = response.data?.data?.find(item => item.id == id);
    }
    
    return pattern;
  } catch (e) {
    console.error("Failed to fetch single pattern detail", e);
    return null;
  }
}

  },
};
</script>
